import $ from "jquery";
import placesAutoComplete from "google/places-auto-complete";
import pageData from "common/page-data";

// Make placesAutoComplete available globally for legacy jQuery code
window.placesAutoComplete = placesAutoComplete;

const possibleProducts = [
  "brand-radius",
  "realtor",
  "realtor-referral",
  "retargeting",
  "insurance-consumer",
  "insurance-referral",
  "local-business-referral",
  "mortgage-referral",
  "mortgage-consumer",
  "tv",
  "tv-zip",
  "wealth-management-consumer",
  "wealth-management-referral",
  "wealth-management-retargeting"
];

async function cityStateAutoComplete(product) {
  const productIdentifier = `.js-${product}-profile-search-form-city-state`;
  if ($(productIdentifier)[0]) {
    try {
      await placesAutoComplete.initializeCityState(
        productIdentifier,
        null,
        pageData.get("currentCountry")
      );
    } catch (error) {
      console.error(`Failed to initialize Places Autocomplete for ${product}:`, error);
    }
  }
}

// Initialize Places Autocomplete for all products
Promise.all(possibleProducts.map(cityStateAutoComplete)).catch(error => {
  console.error("Failed to initialize some Places Autocomplete instances:", error);
});

// Initialize address search for listing forms
if (document.querySelectorAll(".listings-search-form-address").length) {
  placesAutoComplete
    .initializeAddress(".listings-search-form-address", false, pageData.get("currentCountry"))
    .catch(error => {
      console.error("Failed to initialize address search:", error);
    });
}

// Add body class for new Places API (now default)
document.body.classList.add("new-google-places-api");
